export default __webpack_public_path__ + "static/media/OrangeJuice.0d52747d.jpg";